/*global _*/
<template>
  <div
    id="page-body"
    :class="formSchema.form.styleClassesBody"
  >
    <!--LEGACY FORMGEN HEADER-->
    <div
      v-if="formSchema.form && !formSchema.form.hideHeader && _.get(formSchema.form, 'formType')!='formblank'"
      class="pageheader"
    >
      <h1>{{ formSchema.form.title }}</h1>
      <div v-html="formSchema.form.text"></div>
    </div>

    <!--FORMGEN TOP-->
    <!--TODO MOVE TO LAYER BELOW-->

    <vue-form-generator
      v-if="_.get(formSchema.form, 'formType')=='formblank'"
      ref="form"
      :class="'vfg-top-debug ' + formSchema.form.styleClassesBody"
      :tag="formOrDiv"
      :schema="formSchema.pages[0].schema"
      :model="formSchema.model"
      :options="formSchema.options"
    >
    </vue-form-generator>

    <!--LEGACY PAGES-->
    <component
      :is="formOrDiv"
      v-else
      id="formtop"
    >
      <component
        :is="_.get(formSchema.form, 'formType')"
        ref="form"
        :key="formSchema.id"
        :form-schema="formSchema"
        @ontabchange="onTabChange"
      >
      </component>
    </component>
  </div>
</template>

<script>
    var debounce = require('debounce-promise')
    // import _ from 'lodash'
    import { scriptService } from 'Js/feathers';
    import { EventBus } from 'Js/eventBus';

    // import router from 'Js/routes.js';
    const router = () => import('Js/routes.js');
    import { actions } from 'Js/actionsProcessor';
    import { getQueryParams, resolveValidatorFunctions, TranslateJSON } from 'Js/bfUtilities';
    // const getQueryParams = require('Js/bfUtilities').getQueryParams;

    var VueScrollTo = require('vue-scrollto');

    import Cleave from 'cleave.js'
    window.cleave = Cleave // todo move to app.vue ??
    import 'cleave.js/dist/addons/cleave-phone.us';

    // Form Types
    Vue.component('formblank', require('./formblank.vue').default);
    Vue.component('formplain', require('./formplain.vue').default);
    Vue.component('formwizard', require('./formwizard.vue').default);
    Vue.component('formwidget', require('./formwidget.vue').default);

    // Custom Fields  TODO don't reg these as globals, but reg locally is fine.
    Vue.component('fieldFv_input', require('./custom/fv_input.vue').default);
    Vue.component('fieldFv_radios', require('./custom/fv_radios.vue').default);
    Vue.component('fieldHtml', require('./custom/html.vue').default);
    Vue.component('fieldClearfix', require('./custom/clearfix.vue').default);
    Vue.component('fieldBfcheckbox1', require('./custom/bfcheckbox1.vue').default);

    //Testing code splitting for these components
    Vue.component('fieldButton', () =>
        import( /* webpackChunkName: "buttons" */ './custom/button.vue'));
    Vue.component('fieldButton2', () =>
        import( /* webpackChunkName: "buttons" */ './custom/button2.vue'));
    Vue.component('fieldBfcomponent', () =>
        import( /* webpackChunkName: "buttons" */ './custom/bfcomponent.vue'));

    // THESE ARE CODE SPLIT BELOW
    Vue.component('fieldHtmlDev', () =>
        import( /* webpackChunkName: "htmlDev" */ './custom/htmlDev.vue'));
    Vue.component('fieldAccordion', () =>
        import( /* webpackChunkName: "misc1" */ './custom/accordion.vue'));
    Vue.component('fieldAccordion2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/accordion2.vue'));

    Vue.component('fieldVtabs', () =>
        import( /* webpackChunkName: "misc1" */ './custom/vtabs.vue'));
    Vue.component('fieldTabs_form2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/tabs_form2.vue'));
    Vue.component('fieldListrows', () =>
        import( /* webpackChunkName: "misc1" */ './custom/listrows.vue'));
    Vue.component('fieldTabs_form', () =>
        import( /* webpackChunkName: "misc1" */ './custom/tabs_form.vue'));
    Vue.component('fieldTable2', () =>
        import( /* webpackChunkName: "misc1" */ './custom/table2.vue'));
    Vue.component('fieldPanel', () =>
        import( /* webpackChunkName: "misc1" */ './custom/panel.vue'));
    Vue.component('fieldDateRangePicker', () =>
        import( /* webpackChunkName: "misc1" */ './custom/dateRangePicker.vue'));

    Vue.component('fieldPaypal', () =>
        import( /* webpackChunkName: "paypal" */ './custom/paypal.vue'));
    Vue.component('fieldStripe', () =>
        import( /* webpackChunkName: "stripe" */ './custom/stripe.vue'));
    Vue.component('fieldAceeditor', () =>
        import( /* webpackChunkName: "aceeditor" */ './custom/aceeditor.vue'));
    Vue.component('fieldDropzone', () =>
        import( /* webpackChunkName: "dropzone" */ './custom/dropzone.vue'));
    Vue.component('fieldSignature', () =>
        import( /* webpackChunkName: "signature" */ './custom/signature.vue'));
    Vue.component('fieldQuilleditor', () =>
        import( /* webpackChunkName: "quill" */ './custom/quill.vue'));
    Vue.component('fieldGmap', () =>
        import( /* webpackChunkName: "gmap" */ './custom/googleMap.vue'));
    Vue.component('fieldFullCalendar', () =>
        import( /* webpackChunkName: "fullCalendar" */ './custom/fullCalendar.vue'));
    Vue.component('fieldAuthorize', () =>
        import( /* webpackChunkName: "authorize" */ './custom/authorize.vue'));
    Vue.component('fieldUploadcare', () =>
        import( /* webpackChunkName: "uploadcare" */ './custom/uploadcare.vue'));

    // SEO Meta tag injector (invisible field, injects meta tags into <head>)
    Vue.component('fieldSeoMeta', () =>
        import( /* webpackChunkName: "seoMeta" */ './custom/seoMeta.vue'));

    export default {

        name: "formGenerator",

        methods: {

            // Validation Functions
            onFieldValidate: debounce(
                function(value, field, model) {
                    // everything in here is debounced
                    let payload = this.formSchema
                    payload.user = this.$store.state.auth.user
                    payload.validation = {
                        value: value,
                        field: field,
                        model: model
                    }
                    let myPromise = scriptService.create({
                            "service": "formsService.onFieldValidate",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {
                            //TODO how to handle error prettier
                            if (_.get(result, 'error.errorCode')) {
                                BF.errorThrow(10300, 'Error from FMS onValidate', result)

                                alert('fms error: ', result.error)
                                return false
                            }

                            actions.queue(result.actions);
                            this.formSchema = result // ? result.formSchema : this.formSchema;
                            return result.validation.error;
                        })
                        .catch(function(err) {
                            // handle error with an alert / error handler
                            alert('validation scriptServiceCallError : ' + err);
                            return Promise.reject('validation-reject scriptServiceCallError: ' + err);
                        });
                    return myPromise
                },
                500
            ),

            onCustomValidate: (value, field, model) => {
                let app = vueapp.$store.state.site.content.app
                if (!field.validator_calc) {
                    return ["'validator_calc' key is not set for this field"]
                }
                let calc = field.validator_calc
                let errorMsg = field.errorMsg || "'errorMsg' key not set for this field"
                if (eval(calc)) {
                    return [];
                }
                else {
                    return [errorMsg];
                }
            },

            onDataFetch: function(query) {
                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                payload.query = query
                let params = {
                    "service": "formsService.onDataFetch",
                    "data": payload
                }
                let myPromise = this.callFms(params)
                    .then(result => {
                        if (_.get(result, 'error.errorCode')) {
                            alert('fms error (data Fetch): ', result.error.info)
                            return false
                        }
                        actions.queue(result.actions);
                        let data = result.data;
                        delete result.data;
                        this.formSchema = result // ? result.formSchema : this.formSchema;
                        return data
                    })
                    .catch(function() {
                        // handle error with an alert / error handler
                        return Promise.reject('B- This is a custom validation error message.');
                    });

                return myPromise
            },

            onTabChange: function() {
                if (!this.formSchema.options.validateOnServer) {
                    return true
                }

                if (!this.$refs.form.validate()) {
                    return true || false
                }

                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                return new Promise((resolve, reject) => {
                    scriptService.create({
                            "service": "formsService.onTabChange",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {

                            if (_.get(result, 'error.errorCode')) {
                                EventBus.$emit('toaster', {
                                    type: "Warning",
                                    title: "Data Load Error",
                                    msg: "There is an issue returning data : " + result.error,
                                    position: "toast-top-center"
                                });
                                reject(result.error);
                            }

                            result = TranslateJSON(result, this.idWndw);
                            result = resolveValidatorFunctions(result);
                            Object.keys(result).forEach(function(key) {
                                _.isEmpty(result[key]) ? null : this.formSchema[key] = result[key];
                            }.bind(this));

                            actions.queue(result.actions);

                            if (result.state.allowTabChange) {

                                var cancelScroll;
                                var options = {
                                    container: "body",

                                    easing: [0.68, .8, 0.265, 1.55],
                                    // duration: 1500,
                                    offset: 0,
                                    cancelable: true,
                                    onDone: function() {
                                        // scrolling is done
                                    },
                                    onCancel: function() {
                                        // scrolling has been interrupted
                                    },
                                    x: false,
                                    y: true
                                }
                                if (_.get(result, "form.scrolling") == undefined) {
                                    // scroll as normal
                                    VueScrollTo.scrollTo("#main-wrapper", 500, options)
                                }
                                else if (_.isEmpty(_.get(result, "form.scrolling"))) {
                                    // defined as {} so no scroll at all
                                }
                                else {
                                    VueScrollTo.scrollTo("#main-wrapper", result.form.scrolling.options.duration || 500, Object.assign(options, result.form.scrolling.options))
                                }
                                resolve(true)
                            }
                            else {
                                // result.state.TabChangeError = "state.tabChangeError message"
                                reject(result.state.tabChangeError);
                            }

                        })
                        .catch(function(error) {
                            reject(error);
                        });
                })
            },
            
            onUtilityHook: function(hookPackage, callback) {
                // if (!this.$store.getters.isOnline()) return;
                var payload = Object.assign({}, this.formSchema)
                if (!payload.form.sendFullSchema) {
                    delete payload.pages
                    delete payload.options
                    delete payload.site
                    delete payload.form
                    delete payload.modelCaches
                    payload.form = {}
                    payload.form.hookSetName = this.formSchema.form.hookSetName
                }
                delete hookPackage.function
                if (hookPackage.options.model || hookPackage.options.modelFilterKeys) {
                    _.set(payload, 'state.modelUpdateMode', 'merge')
                }
                hookPackage.options.model ? payload.model = hookPackage.options.model : null
                hookPackage.options.modelFilterKeys ? payload.model = _.pick(payload.model, hookPackage.options.modelFilterKeys) : null
                delete hookPackage.options.modelFilterKeys
                payload.hookPackage = hookPackage
                payload.query = hookPackage.options.query || getQueryParams()
                let params = {
                    "service": "formsService.onUtility",
                    "data": payload
                }

                this.callFms(params) // returns a promise
                    .then(function(result) {
                        if (result.code) { throw result }

                        if (_.get(result, 'error.errorCode')) {
                            //Send to error handler
                            alert('fms error (onUtilityHook): ', result.error.info)
                            return false
                        }

                        const returnedApp = result.app && _.isObject(result.app) ? _.cloneDeep(result.app) : null
                        this.$store.commit('SET_APP', result.app);
                        delete result.app;

                        actions.queue({ actions: result.actions, idThread: hookPackage.idThread, insert: true, idForm: hookPackage.idForm });

                        delete result.actions;
                        if (this.formSchema.id === hookPackage.idForm && hookPackage.idForm) {
                            const returnedModel = result.model && _.isObject(result.model) ? _.cloneDeep(result.model) : null
                            // Default to merge when model is returned (preserves client-side reactive properties)
                            if (result.model && !_.get(result, 'state.modelUpdateMode')) {
                                _.set(result, 'state.modelUpdateMode', 'merge')
                            }
                            _.get(result, 'state.modelUpdateMode') == 'merge' ?
                                result.model = Object.assign(this.formSchema.model, result.model) :
                                null
                            delete result.state.modelUpdateMode

                            // Keep appSync keys aligned after utility hooks.
                            // Priority: when both app and model return the same appSync key, app wins.
                            if ((returnedModel || returnedApp) && Array.isArray(this.formSchema.modelCaches)) {
                                const appSyncPatch = {}
                                const modelFromAppPatch = {}
                                this.formSchema.modelCaches.forEach(cacheCfg => {
                                    if (!cacheCfg || !cacheCfg.appSync || !cacheCfg.path) return

                                    const hasReturnedApp = returnedApp && Object.prototype.hasOwnProperty.call(returnedApp, cacheCfg.path)
                                    const hasReturnedModel = returnedModel && Object.prototype.hasOwnProperty.call(returnedModel, cacheCfg.path)

                                    if (hasReturnedApp) {
                                        modelFromAppPatch[cacheCfg.path] = returnedApp[cacheCfg.path]
                                        return
                                    }

                                    if (hasReturnedModel) {
                                        appSyncPatch[cacheCfg.path] = this.formSchema.model[cacheCfg.path]
                                    }
                                })

                                if (!_.isEmpty(modelFromAppPatch)) {
                                    Object.assign(this.formSchema.model, modelFromAppPatch)
                                }
                                if (!_.isEmpty(appSyncPatch)) {
                                    this.$store.commit('SET_APP', appSyncPatch)
                                }
                            }

                            delete result.form
                            if (!_.isEmpty(result.pages) && !_.isEqual(this.formSchema.pages, result.pages)) {
                                this.formSchema.pages = result.pages
                            }

                            delete result.pages

                            if (!_.isEmpty(result.options)) {
                                this.formSchema.options = result.options
                                delete result.options
                            }

                            Object.keys(result).forEach(function(key) {
                                _.isEmpty(result[key]) ? null : this.formSchema[key] = result[key]
                            }.bind(this));

                            return result
                        }
                        return result;

                    }.bind(this))
                    .then(result => {
                        result = TranslateJSON(result, this.idWndw);
                        result = resolveValidatorFunctions(result);
                        // Call the callback to signal completion
                        if (typeof callback === 'function') {
                            callback(result);
                        }
                        return result
                    })
                    .catch(e => {
                        BF.errorThrow(e);
                        // Call the callback even on error
                        if (typeof callback === 'function') {
                            callback(null);
                        }
                        return false;
                    })
            },
            
            onComplete: function(callback) {
                // call child validate method
                if (!this.$refs.form.validate()) {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    return false
                }

                // if actions set then do, else run
                if (typeof this.formSchema.form.wizardOnComplete === "function") {
                    this.formSchema.form.wizardOnComplete()
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    return
                }

                let payload = this.formSchema
                payload.user = this.$store.state.auth.user
                return new Promise((resolve, reject) => {
                    scriptService.create({
                            "service": "formsService.onComplete",
                            "data": payload // send back everything just in case we need
                        })
                        .then(result => {
                            // actions.queue(result.actions);
                            this.$store.dispatch('ACTIONS_QUEUE', result.actions);
                            this.formSchema = result
                            // maybe add a default action if no action passed
                            if (!result.actions) {
                                router.push("/")
                            }
                            // return 
                            resolve(true)
                        })
                        .catch(function(error) {
                            // handle error with an alert / error handler
                            EventBus.$emit('toaster', {
                                type: "Warning",
                                title: "Data Load Error",
                                msg: "There is an issue returning data: " + error,
                                position: "top-center"
                            })
                            reject(error)
                        });
                }).then(result => {
                    if (typeof callback === 'function') {
                        callback(result);
                    }
                    return result;
                }).catch(error => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    throw error;
                })

            },

            callFms: function(params) {
                let myPromise = scriptService.create(params)
                    .then(result => {
                        return result;
                    })
                    .catch(function(error) {
                        return error;
                    });
                return myPromise;
            },

            processNamedAction: function(namedAction) {
                //idThread should be on higher level, not under options
                let actionsObj = _.get(this, 'formSchema.form.namedActions[' + namedAction.name + ']')
                // fallback via store getter (site-level, then component scan)
                actionsObj = actionsObj || this.$store.getters.getSiteNamedAction(namedAction.name)

                if (!actionsObj && (namedAction.name === 'appIsOnline' || namedAction.name === 'appIsOffline')) {
                    return;
                }

                if (!actionsObj) {
                    namedAction.idThread ? this.$store.commit('SET_PENDINGTRHEADS', namedAction.idThread) : null;
                    BF.errorThrow(10110, `namedAction ${namedAction.name} was not found for action `, namedAction)
                    return
                }

                var actionsArray = []
                Array.isArray(actionsObj) ? actionsArray = actionsObj : actionsArray.push(actionsObj)
                actionsArray = _.cloneDeep(actionsArray);

                var idThread = namedAction.idThread ? namedAction.idThread : Date.now();

                // mix in options
                for (var i = 0, len = actionsArray.length; i < len; i++) {
                    actionsArray[i].options ? null : actionsArray[i].options = {}
                    actionsArray[i].options = Object.assign(actionsArray[i].options, namedAction.options || {})
                    actionsArray[i].idThread = idThread
                }

                // this.processActions(actionsArray);
                this.$store.dispatch('ACTIONS_QUEUE', {
                    actions: actionsArray,
                    insert: true,
                    idThread: idThread
                });

            },

            processActions: function(actionsObj) {
                // expects: {} or  []
                var actionsArray = []
                if (Array.isArray(actionsObj)) {
                    actionsArray = actionsObj
                }
                else {
                    actionsArray.push(actionsObj)
                }

                actions.queue(actionsArray);
            },

            doValidation: async function(action) {
                try {
                    // Await the validation result
                    await this.$refs.form.validate();
                    actions.process(action);
                } catch (error) {
                    // Handle any errors from the validation process
                    this.$store.dispatch('ACTIONS_CLEAR', action);
            
                    if (typeof action.onFailed === "function") {
                        action.onFailed();
                    }
                }
            },

            processWidgetPayload: function(payload) {
                this.formSchema.model = Object.assign({}, this.formSchema.model, payload.model)
            },

            executeFunction: async function(action, callback) {
                if (action.function) {
                    try {
                        var params1 = this.$store.state.site.content.params || {};
                        var app1 = this.$store.state.site.content.app;
                        // Ensure the user function ends cleanly even if it has a trailing comment
                        const functionBody = `${action.function}\n`;
                        var funct = new Function('formSchema', 'model', 'action', 'app', 'params', 'args', 'EventBus', `return (async function(formSchema, model, action, app, params, args, EventBus) { ${functionBody} })(formSchema, model, action, app, params, args, EventBus);`);
                        var result = await funct(this.formSchema, this.formSchema.model, action, app1, params1, _.get(action, 'options.args'), EventBus);
            
                        this.$store.commit('SET_PARAMS', params1);
                        this.$store.commit('SET_APP', app1);
                        BF.rebuildReactivity(this.formSchema.model);
                        
                        // Call callback with result when done
                        if (callback) callback(result);
                    } catch (error) {
                        var actionName = action.name || action.action || 'unnamed';
                        var snippet = (action.function || '').substring(0, 200);

                        // Grouped console output for easy inspection
                        console.groupCollapsed(`%c⚠ executeFunction error in "${actionName}": ${error.message}`, 'color: #e74c3c; font-weight: bold');
                        console.log('%cAction Name', 'font-weight:bold', actionName);
                        console.log('%cError', 'font-weight:bold', error.message);
                        console.log('%cCode Snippet', 'font-weight:bold', '\n' + (action.function || ''));
                        if (action.options) console.log('%cOptions', 'font-weight:bold', action.options);
                        console.groupEnd();

                        BF.errorThrow(
                            10501,
                            `executeFunction error in action "${actionName}": ${error.message}`,
                            {
                                action: action.action,
                                name: action.name,
                                functionSnippet: snippet,
                                options: action.options
                            }
                        );
                        // Call callback with error
                        if (callback) callback({ error });
                    }
                }
            },
            clearListeners: function() {
                var events = ['runUtilityHook', 'onDataFetch', 'runOnCompleteHook', 'processNamedAction', 'validate',
                    'processWidgetPayload', 'processActions', 'executeFunction'
                ]
                var _this = this
                events.forEach(function(event) {
                    EventBus.$off(event, _this.listners[event + '_' + _this._uid])
                });

            }
        },

        created() {
            window.formGen = this // this allows the this to be accessed from some 
            window.VueFormGenerator.validators.fmsHook = this.onFieldValidate
            window.VueFormGenerator.validators.calc = this.onCustomValidate
            this.formSchema = resolveValidatorFunctions(this.formSource)
        },

        beforeMount() {},

        mounted() {
            // this.formSchema = this.formSource
            var _this = this

            // register EventBus func's
            const busReg = (event, cb) => {
                // register a unique event
                var name = event + '_' + _this._uid
                var fn = function() {
                    // Accept all arguments from EventBus.$emit
                    var allArgs = Array.prototype.slice.call(arguments);
                    var arg = allArgs[0];
                    
                    // check if the event came from this wndw else return
                    if (
                        _this.$store.getters.getActiveWindow == _this.formSchema.options.idWndw
                        // !activeWndw || // no activeW
                        // arg.idWndw == thisIdWndw || // no active but intented for this windw?
                        // (activeWndw.id == thisIdWndw && arg.idWndw == undefined) // has id but not explicitly set
                    ) {
                        // Pass all arguments through to the callback
                        var args = []
                        args[0] = arg ? arg.payload || arg : null
                        // Include any additional arguments (like callbacks)
                        for (var i = 1; i < allArgs.length; i++) {
                            args[i] = allArgs[i];
                        }
                        cb.apply(_this, args)
                    }
                }

                // console.log('creating listers: ', name )
                Object.defineProperty(fn, "name", { value: name });
                _this.listners[name] = fn
                EventBus.$on(event, fn);
            };


            // Set up Custom Validators
            window.VueFormGenerator.validators.fmsHook = this.onFieldValidate
            window.VueFormGenerator.validators.calc = this.onCustomValidate

            busReg('onDataFetch', (query, done) => {
                this.onDataFetch(query)
                    .then(result => {
                        done(result)
                    })
            });
            /*busReg('runUtilityHook', this.onUtilityHook);
            busReg('runOnCompleteHook', this.onComplete);*/
            busReg('runUtilityHook', (hookPackage, callback) => {
                this.onUtilityHook(hookPackage, callback);
            });
            busReg('runOnCompleteHook', (action, callback) => {
                this.onComplete(callback);
            });
            busReg('processNamedAction', this.processNamedAction);
            busReg('validate', this.doValidation);
            busReg('processWidgetPayload', this.processWidgetPayload);
            busReg('executeFunction', this.executeFunction);
            busReg('processActions', this.processActions);

        },

        beforeDestroy() {
            this.clearListeners()
        },

        destroyed() {},

        props: {
            formSource: {
                type: Object
            },
            loading: {
                type: Boolean
            },
            idWndw: {
                default: 0,
                type: Number
            }
        },

        computed: {

            theModel: function() {
                return this.formSchema.model
            },

            formOrDiv: function() {
                return this.formSchema.form && this.formSchema.form.isForm ? 'form' : 'div'
            },

            slots: function() {
                return _.get(this.formSchema, 'form.slots') || []
            },
        },

        data: function() {
            return {
                formSchema: {},
                // schemaStore: {},
                listners: {} // holds event wrappers
            }
        }

    }
</script>

<style src="../../../css/vfg.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css"></style>
<style>
.multiselect--active { z-index: 10; }
</style>
